import axios from 'axios';
import { api } from './client';

// The UAM gate must remain reachable even when /api/* is otherwise locked
// by Under-Attack Mode, so we use a raw axios call without the standard
// auth interceptor for the status check.
const rawClient = axios.create({
  // Same-origin unless REACT_APP_BACKEND_URL points elsewhere (plan P4.2).
  baseURL: process.env.REACT_APP_BACKEND_URL || '',
  withCredentials: true,
  timeout: 8000,
});

export const fetchUamStatus = () => rawClient.get('/api/uam/status').then((r) => r.data);

export const requestUamChallenge = () => rawClient.post('/api/uam/challenge').then((r) => r.data);

export const submitUamVerify = (token, nonce, checkbox) => rawClient.post('/api/uam/verify', { token, nonce, checkbox }).then((r) => r.data);

// Admin
export const fetchUamStats = () => api.get('/api/admin/uam/stats').then((r) => r.data);

export const resetUamStats = () => api.post('/api/admin/uam/reset').then((r) => r.data);
